module.exports = __webpack_public_path__ + "public/img/login_logo.53994088.png";